"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAuthToken = getAuthToken;
exports["default"] = exports.initialState = exports.updatePerson = exports.updateAPI = exports.logout = exports.fetchPerson = exports.AUTH_UPDATE_PERSON = exports.AUTH_UPDATE_API = exports.AUTH_PERSON_FETCH_SUCCESS = exports.AUTH_PERSON_FETCH_ERROR = exports.AUTH_PERSON_FETCH = exports.AUTH_LOGOUT = void 0;

var _last2 = _interopRequireDefault(require("lodash/last"));

var authentication = _interopRequireWildcard(require("./authentication.js"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var authenticationReducer = authentication["default"],
    defaultInitialState = authentication.initialState,
    restOfAuthentication = _objectWithoutProperties(authentication, ["default", "initialState"]);

var AUTH_LOGOUT = restOfAuthentication.AUTH_LOGOUT,
    AUTH_PERSON_FETCH = restOfAuthentication.AUTH_PERSON_FETCH,
    AUTH_PERSON_FETCH_ERROR = restOfAuthentication.AUTH_PERSON_FETCH_ERROR,
    AUTH_PERSON_FETCH_SUCCESS = restOfAuthentication.AUTH_PERSON_FETCH_SUCCESS,
    AUTH_UPDATE_API = restOfAuthentication.AUTH_UPDATE_API,
    AUTH_UPDATE_PERSON = restOfAuthentication.AUTH_UPDATE_PERSON,
    fetchPerson = restOfAuthentication.fetchPerson,
    logout = restOfAuthentication.logout,
    updateAPI = restOfAuthentication.updateAPI,
    updatePerson = restOfAuthentication.updatePerson;
/**
 * Acts as a pass-through to the standard Authentication reducer
 * in order to set a different initial state based on a browser/web
 * environment.
 */

exports.updatePerson = updatePerson;
exports.updateAPI = updateAPI;
exports.logout = logout;
exports.fetchPerson = fetchPerson;
exports.AUTH_UPDATE_PERSON = AUTH_UPDATE_PERSON;
exports.AUTH_UPDATE_API = AUTH_UPDATE_API;
exports.AUTH_PERSON_FETCH_SUCCESS = AUTH_PERSON_FETCH_SUCCESS;
exports.AUTH_PERSON_FETCH_ERROR = AUTH_PERSON_FETCH_ERROR;
exports.AUTH_PERSON_FETCH = AUTH_PERSON_FETCH;
exports.AUTH_LOGOUT = AUTH_LOGOUT;

var initialState = _objectSpread(_objectSpread({}, defaultInitialState), {}, {
  api: _objectSpread(_objectSpread({}, defaultInitialState.api), {}, {
    token: getAuthToken()
  })
});

exports.initialState = initialState;

function getAuthToken() {
  var subdomain = window.location.hostname.split('.')[0];
  var regexpString = "( |^)auth_token_".concat(subdomain, "=([^ ;]+)");
  var subdomainTokenMatch = document.cookie.match(regexpString);
  if (subdomainTokenMatch) return (0, _last2["default"])(subdomainTokenMatch);
  var legacyTokenMatch = document.cookie.match(/( |^)auth_token=([^ ;]+)/);
  return legacyTokenMatch ? (0, _last2["default"])(legacyTokenMatch) : '';
}

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return authenticationReducer(state, action);
};

exports["default"] = _default;